import { RecentlyViewed } from './recently-viewed-products.js';

/**
 * Tracks the current product view and adds it to recently viewed products
 */
class TrackProductView extends HTMLElement {
  connectedCallback() {
    const productId = this.dataset.productId;

    if (productId) {
      RecentlyViewed.addProduct(productId);
    }
  }
}

if (!customElements.get('track-product-view')) {
  customElements.define('track-product-view', TrackProductView);
}
